// src/data/claimLanguage.js
//
// RULING 265 (2026-09-30) - the client half of the language assistant (functions\claimLanguage.js is the server
// half). Pure: what the claim tells the assistant, and how the answer is marked on screen.
import { guidedQuestions } from './box1Guided';   // pure, imports nothing
const s = (v) => (v == null ? '' : String(v)).trim();
const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
function longDate(v) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s(v));
  return m ? MONTHS[+m[2] - 1] + ' ' + (+m[3]) + ', ' + m[1] : s(v);
}

// The claim record the statement may draw on - nothing else is sent.
// Bob 2026-10-17 (plan YCP_PLAN_OVERTIME_CLAIM_FACTS_2026-10-17.md): the Box 1 answers were never sent, so the job, the
// vacancy and both men's standing could not reach the Statement of Claim. Each answered question now goes with its answer.
export function factsFromClaim(c) {
  const claim = c || {};
  const a = (claim.box1Answers && typeof claim.box1Answers === 'object') ? claim.box1Answers : {};
  const answers = (claim.claimKind ? guidedQuestions(claim.claimKind) : [])
    .filter(({ id }) => s(a[id]))
    .slice(0, 12)
    .map(({ id, q }) => ({ q, a: s(a[id]) }));
  return {
    answers,
    claimant: s(claim.claimantName),
    date: longDate(claim.incidentDate),
    time: s(claim.incidentTime24 || claim.incidentTime),
    place: s(claim.eventLocation || claim.workLocation),
    carrier: s(claim.railroad),
    agreement: s(claim.applicableAgreement),
    other: s(claim.violatorName),
    rules: (Array.isArray(claim.matchedRules) ? claim.matchedRules : []).filter(r => r && r.rule && !r.setAsideAt)
      .slice(0, 6).map(r => ({ rule: s(r.rule), quote: s(r.exactLanguage) })),
  };
}

// The answer split into plain and marked pieces: every word the server listed as not found in his words or the claim.
export function markUnsupported(text, unsupported) {
  const t = String(text || '');
  const list = (Array.isArray(unsupported) ? unsupported : []).filter(Boolean).sort((a, b) => b.length - a.length);
  if (!list.length) return [{ text: t, bad: false }];
  const esc = (x) => x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const re = new RegExp('(' + list.map(w => (/^\w/.test(w) ? '\\b' : '') + esc(w) + (/\w$/.test(w) ? '\\b' : '')).join('|') + ')', 'g');
  const out = []; let last = 0; let m;
  while ((m = re.exec(t))) {
    if (m.index > last) out.push({ text: t.slice(last, m.index), bad: false });
    out.push({ text: m[0], bad: true });
    last = m.index + m[0].length;
    if (m[0].length === 0) re.lastIndex++;
  }
  if (last < t.length) out.push({ text: t.slice(last), bad: false });
  return out;
}

// Still carrying a word that was not in his account or on the claim? Then it may not be used until he has looked.
export function stillUnsupported(text, unsupported) {
  const t = String(text || '');
  return (Array.isArray(unsupported) ? unsupported : []).filter(w => w && t.includes(w));
}
